import React from 'react';
import { View } from 'react-native';
import { REBOOK_ENABLED } from '../../env.rebook';
import { CommonStyles } from '../../styles';
import InvoiceAirSummaryList from './InvoiceAirSummaryList';
import InvoiceCarSummaryList from './InvoiceCarSummaryList';
import InvoiceHotelSummaryList from './InvoiceHotelSummaryList';
// import RailSummaryList from './RailSummaryList';

const InvoiceSummaryList = ({
  airList,
  airlistMultiPnr,
  carList,
  hotelList,
  passengers,
  railList,
}) => {
  return (
    <View style={CommonStyles.flex1}>
      {airList &&
        airList.map((response) => (
          <InvoiceAirSummaryList
            key={response.ResponseID}
            price={response.TotalCost}
            response={response}
            multiPnrResp={airlistMultiPnr}
            onSelect={() => {}}
          />
        ))}
      {carList &&
        carList.map((response) => (
          <InvoiceCarSummaryList
            key={response.ResponseId}
            passengers={passengers}
            response={response}
            onSelect={() => {}}
          />
        ))}
      {hotelList &&
        hotelList.map((response) => (
          <InvoiceHotelSummaryList
            key={response.HotelId + response.CheckInDate}
            passengers={passengers}
            response={response}
            onSelect={() => {}}
          />
        ))}
      {/* {railList && railList && railList.RailLegs && railList.RailLegs.length > 0 && (
        <RailSummaryList response={railList} onSelect={() => {}} />
      )} */}
    </View>
  );
};
export default InvoiceSummaryList;
